// removed by extract-text-webpack-plugin
module.exports = {"dialogContent":"ErrorDialog__dialogContent___1u5bv","title":"ErrorDialog__title___3AO3b","closeIcon":"ErrorDialog__closeIcon___2__z_","dialogTheme":"ErrorDialog__dialogTheme___3FT6y"};


//////////////////
// WEBPACK FOOTER
// ./src/card/CardDialogs/ErrorDialog/ErrorDialog.scss
// module id = 1221
// module chunks = 0